"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortedContactList = void 0;
const sortedIndexBy_1 = __importDefault(require("lodash/sortedIndexBy"));
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const PeerManager_1 = require("../PeerManager");
const identifiers_1 = require("../../identifiers");
class SortedContactList extends eventemitter3_1.default {
    options;
    contactsById = new Map();
    contactIds = [];
    constructor(options) {
        super();
        this.options = options;
        this.compareIds = this.compareIds.bind(this);
    }
    getClosestContactId() {
        return this.contactIds[0];
    }
    getContactIds() {
        return this.contactIds;
    }
    addContact(contact) {
        const contactId = contact.getNodeId();
        if (this.options.excludedNodeIds?.has(contactId)) {
            return;
        }
        if ((!this.options.allowToContainReferenceId && (this.options.referenceId === contactId)) ||
            (this.options.nodeIdDistanceLimit !== undefined && this.compareIds(this.options.nodeIdDistanceLimit, contactId) < 0)) {
            return;
        }
        if (!this.contactsById.has(contactId)) {
            if ((this.options.maxSize === undefined) || (this.contactIds.length < this.options.maxSize)) {
                this.contactsById.set(contactId, contact);
                const index = (0, sortedIndexBy_1.default)(this.contactIds, contactId, (id) => { return this.distanceToReferenceId(id); });
                this.contactIds.splice(index, 0, contactId);
                if (this.hasEventListeners()) {
                    this.emit('contactAdded', contact);
                }
            }
            else if (this.compareIds(this.contactIds[this.options.maxSize - 1], contactId) > 0) {
                const removedId = this.contactIds.pop();
                const removedContact = this.contactsById.get(removedId);
                this.contactsById.delete(removedId);
                this.contactsById.set(contactId, contact);
                const index = (0, sortedIndexBy_1.default)(this.contactIds, contactId, (id) => { return this.distanceToReferenceId(id); });
                this.contactIds.splice(index, 0, contactId);
                if (this.hasEventListeners()) {
                    this.emit('contactRemoved', removedContact);
                    this.emit('contactAdded', contact);
                }
            }
        }
    }
    addContacts(contacts) {
        contacts.forEach((contact) => this.addContact(contact));
    }
    getContact(id) {
        return this.contactsById.get(id);
    }
    has(id) {
        return this.contactsById.has(id);
    }
    /*
     * Closest first then others in ascending distance order
     */
    getClosestContacts(limit) {
        const limitedContactIds = (limit === undefined) ? this.contactIds : this.contactIds.slice(0, Math.max(limit, 0));
        return limitedContactIds.map((nodeId) => this.contactsById.get(nodeId));
    }
    /*
     * Furthest first then others in descending distance order
     */
    getFurthestContacts(limit) {
        const ret = [...this.getClosestContacts()].reverse();
        return (limit === undefined)
            ? ret
            : ret.slice(0, Math.max(limit, 0));
    }
    compareIds(id1, id2) {
        const distance1 = this.distanceToReferenceId(id1);
        const distance2 = this.distanceToReferenceId(id2);
        return distance1 - distance2;
    }
    // TODO inline this method?
    distanceToReferenceId(id) {
        // TODO maybe this class should store the referenceId also as DhtAddressRaw so that we don't need to convert it here?
        return (0, PeerManager_1.getDistance)((0, identifiers_1.toDhtAddressRaw)(this.options.referenceId), (0, identifiers_1.toDhtAddressRaw)(id));
    }
    removeContact(id) {
        if (this.contactsById.has(id)) {
            const removed = this.contactsById.get(id);
            // TODO use sortedIndexBy?
            const index = this.contactIds.findIndex((nodeId) => (nodeId === id));
            this.contactIds.splice(index, 1);
            this.contactsById.delete(id);
            if (this.hasEventListeners()) {
                this.emit('contactRemoved', removed);
            }
            return true;
        }
        return false;
    }
    getAllContactsInUndefinedOrder() {
        return this.contactsById.values();
    }
    getSize(excludedNodeIds) {
        let excludedCount = 0;
        if (excludedNodeIds !== undefined) {
            for (const nodeId of excludedNodeIds) {
                if (this.has(nodeId)) {
                    excludedCount++;
                }
            }
        }
        return this.contactIds.length - excludedCount;
    }
    clear() {
        this.contactsById.clear();
        this.contactIds = [];
    }
    stop() {
        this.removeAllListeners();
        this.clear();
    }
    hasEventListeners() {
        return this.eventNames().length > 0;
    }
}
exports.SortedContactList = SortedContactList;
//# sourceMappingURL=SortedContactList.js.map